import browser from "webextension-polyfill";
import { Prefs } from "../../alias/prefs";
import { commandStorageKey } from "./command-library.types";
import { recordEvent } from "./event-recording";
export async function checkLanguage(ipmId) {
    var _a;
    await Prefs.untilLoaded;
    const commandStorage = Prefs.get(commandStorageKey);
    if (!(ipmId in commandStorage)) {
        return;
    }
    const command = commandStorage[ipmId];
    if (typeof ((_a = command.attributes) === null || _a === void 0 ? void 0 : _a.language) !== "string") {
        return;
    }
    if (browser.i18n.getUILanguage() === command.attributes.language) {
        return;
    }
    recordEvent(command.ipm_id, command.command_name, "language_skew");
}
